import AccountLoadingForm from './AccountLoadingForm';

export * from './AccountLoadingForm';
export default AccountLoadingForm;
